<template>
  <div class="table-responsive opSecHorizontalFormContainer">
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th
            style="min-width: 270px;"
            v-for="question in visibleQuestions"
            :key="question.item_id">
            {{ question.label }}
          </th>
        </tr>
      </thead>
      <tr :style="!isHorizontal ? 'display:flex; flex-direction: column;':  ''">
        <td
          style="vertical-align: top;"
          v-for="field in visibleQuestions"
          :key="field.item_id">
          <div :class="{horizontalFormFieldContainer: isHorizontal}">
            <component
              v-if="showFields && field.type !== 'folio'"
              :is="resolveComponent(field.type)"
              :field="field"
              @updateData="updateModel"
              @setLastFacilitySelected="setLastFacilitySelected"
              :isFormDisabled="isFormDisabled"
              :errors="errors"
              :onUpdateFiles="onUpdateFiles"
              :disabled="isFormDisabled"
              :isHorizontal="isHorizontal"
              :label="isHorizontal ? '' : field.name"
              :withSmallTooltip="true"
              :onlyImages="supportOnlyImages(field)"
              :lastFacilitySelected="lastFacilitySelected"
              :lastRegionOfFacilitySelected="lastRegionOfFacilitySelected"
              @wheel.native="blockNumberWheel"
              @keydown.native="blockSubmit"
            />
          </div>
        </td>
        <td>
          <b-button
            :disabled="isFormDisabled"
            variant="info"
            class="mb-2"
            @click="submitForm">
            {{ $t("actions.save") }}
          </b-button>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { onMounted, ref, watch } from "@vue/composition-api";
import useHorizontalForm from "./useHorizontalForm";

export default {
  props: {
    templateData: {
      type: Object,
      default: () => ({}),
    }
  },
  components: {
  },
  setup(props, { emit, root }) {
    const {
      model,
      questionsNames,
      isFormDisabled,
      headerNames,
      errors,
      showFields,
      lastFacilitySelected,
      lastRegionOfFacilitySelected,
      isHorizontal,
      visibleQuestions,
      initForm,
      isFieldVisible,
      resolveComponent,
      updateModel,
      submitForm,
      onUpdateFiles,
      supportOnlyImages,
      setLastFacilitySelected,
      blockNumberWheel,
      blockSubmit
    } = useHorizontalForm(emit);

    onMounted(async () => {
      initForm(props.templateData)
    });

    return {
      model,
      questionsNames,
      isFormDisabled,
      errors,
      showFields,
      lastFacilitySelected,
      lastRegionOfFacilitySelected,
      isHorizontal,
      headerNames,
      visibleQuestions,
      isFieldVisible,
      resolveComponent,
      updateModel,
      submitForm,
      onUpdateFiles,
      supportOnlyImages,
      setLastFacilitySelected,
      blockNumberWheel,
      blockSubmit
    };
  },
};
</script>
<style scoped lang="scss">
.horizontalFormFieldContainer {
  max-height: 90px;
}
.dark-layout {
  .opSecHorizontalFormContainer {
    background-color: var(--main-dark) !important;
  }
}
</style>
